'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, NativeSelect, OutlinedInput, Typography } from '@mui/material';
import { useShallow } from 'zustand/shallow';
import { useBTCalculatorStore } from './calculatorStore';
const SelectIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  const t1 = `mask-icon mask-icon-keyboard-arrow-down${className ? ` ${className}` : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "1.5rem",
      height: "1.5rem"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <span className={t1} style={t2} />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
const SELECT_OPTIONS = [{
  value: 0,
  label: '0%'
}, {
  value: 0.01,
  label: '1%'
}, {
  value: 0.02,
  label: '2%'
}, {
  value: 0.03,
  label: '3%'
}, {
  value: 0.04,
  label: '4%'
}, {
  value: 0.05,
  label: '5%'
}];
export const BalanceTransferDetailsForm = () => {
  const $ = _c(29);
  const {
    balanceTransferFee,
    zeroInterestPeriod,
    zeroInterestPeriodError,
    setField
  } = useBTCalculatorStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      flexDirection: "column",
      bgcolor: "neutral.lightest",
      borderRadius: 2,
      padding: 3,
      gap: 3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="textBold" sx={{
      fontSize: "18px"
    }}>Balance transfer card details</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      flexDirection: "column"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography component="label" htmlFor="balance-transfer-fee-input" variant="textSmallBold" sx={{
      marginBottom: 1
    }}>Balance transfer fee</Typography>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setField) {
    t4 = e => setField("balanceTransferFee", Number(e.target.value));
    $[4] = setField;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      border: "1px solid",
      borderColor: "neutral.lighter",
      width: "100%",
      "&:hover": {
        borderColor: "neutral.dark"
      },
      "&.Mui-focused": {
        boxShadow: "0 0 0 .05rem #008254",
        borderColor: "greens.main"
      },
      "& .MuiNativeSelect-outlined": {
        paddingX: 3,
        paddingY: 2
      },
      ".MuiNativeSelect-icon": {
        height: "1.5rem",
        width: "1.5rem",
        top: "calc(50% - .75rem)"
      },
      bgcolor: "white",
      borderRadius: 2
    };
    t6 = SELECT_OPTIONS.map(_temp2);
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== balanceTransferFee || $[9] !== t4) {
    t7 = <Box sx={t2}>{t3}<NativeSelect variant="outlined" disableUnderline={true} IconComponent={SelectIcon} id="balance-transfer-fee-input" value={balanceTransferFee} onChange={t4} sx={t5}>{t6}</NativeSelect></Box>;
    $[8] = balanceTransferFee;
    $[9] = t4;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      flexDirection: "column"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Typography component="label" htmlFor="0-interest-input" variant="textSmallBold" sx={{
      marginBottom: 1
    }}>Number of months in 0% interest period</Typography>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Typography sx={{
      color: "neutral.main"
    }}>months</Typography>;
    t11 = {
      inputMode: "numeric"
    };
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  let t12;
  if ($[15] !== setField) {
    t12 = e_0 => {
      const value_0 = e_0?.target.value;
      if (!/^\d{0,2}$/.test(value_0)) {
        return;
      }
      setField("zeroInterestPeriod", value_0);
    };
    $[15] = setField;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      "& .MuiOutlinedInput-input": {
        paddingX: 3,
        paddingY: 2
      },
      bgcolor: "white",
      borderRadius: 2
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12 || $[19] !== zeroInterestPeriod) {
    t14 = <OutlinedInput id="0-interest-input" endAdornment={t10} inputProps={t11} value={zeroInterestPeriod} onChange={t12} sx={t13} />;
    $[18] = t12;
    $[19] = zeroInterestPeriod;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== zeroInterestPeriodError) {
    t15 = zeroInterestPeriodError && <Typography variant="textExtraSmall" sx={{
      color: "reds.main",
      marginTop: 1
    }}>{zeroInterestPeriodError}</Typography>;
    $[21] = zeroInterestPeriodError;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <Box sx={t8}>{t9}{t14}{t15}</Box>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t16 || $[27] !== t7) {
    t17 = <Box sx={t0}>{t1}{t7}{t16}</Box>;
    $[26] = t16;
    $[27] = t7;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
};
function _temp(state) {
  return {
    balanceTransferFee: state.form.balanceTransferFee,
    zeroInterestPeriod: state.form.zeroInterestPeriod,
    zeroInterestPeriodError: state.errors.zeroInterestPeriod,
    setField: state.setField
  };
}
function _temp2(t0) {
  const {
    value,
    label
  } = t0;
  return <option key={label} value={value}>{label}</option>;
}